var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6069 4.58063L8.54438 1.51813C8.4829 1.45657 8.39949 1.42195 8.3125 1.42188H3.0625C2.85944 1.42188 2.6647 1.50254 2.52112 1.64612C2.37754 1.7897 2.29688 1.98444 2.29688 2.1875V11.8125C2.29688 12.0156 2.37754 12.2103 2.52112 12.3539C2.6647 12.4975 2.85944 12.5781 3.0625 12.5781H10.9375C11.1406 12.5781 11.3353 12.4975 11.4789 12.3539C11.6225 12.2103 11.7031 12.0156 11.7031 11.8125V4.8125C11.703 4.72551 11.6684 4.6421 11.6069 4.58063ZM8.64062 2.54188L10.5831 4.48438H8.64062V2.54188ZM10.9375 11.9219H3.0625C3.03349 11.9219 3.00567 11.9104 2.98516 11.8898C2.96465 11.8693 2.95312 11.8415 2.95312 11.8125V2.1875C2.95312 2.15849 2.96465 2.13067 2.98516 2.11016C3.00567 2.08965 3.03349 2.07812 3.0625 2.07812H7.98438V4.8125C7.98438 4.89952 8.01894 4.98298 8.08048 5.04452C8.14202 5.10605 8.22548 5.14062 8.3125 5.14062H11.0469V11.8125C11.0469 11.8415 11.0354 11.8693 11.0148 11.8898C10.9943 11.9104 10.9665 11.9219 10.9375 11.9219Z",
    fill: "#D2D3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.d8ac5320a6d02a7df5494740cedc9312.svg";
export { ForwardRef as ReactComponent };